//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Button, IconButton, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
// import MuiAccordion from '@material-ui/core/Accordion';
// import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
// import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { ArrowRight, Close, Visibility } from '@mui/icons-material';
import { Col, Row } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
//  -- Constants ----------------------
import PasswordRevealInline from 'components/PasswordRevealInline';
import COLOR from 'utils/constants/color';
//  -- Components ---------------------
import Loading from 'components/Loading';
import LoadingWrapper from 'components/LoadingWrapper';
import { UserInfoCard, IntegrationUserCard, ModalContent, ModalSection, Accordion, AccordionSummary, AccordionDetails, AccordianTitle, Rotate, SearchForm, ClassInfoCard } from 'components/UserView';
import { handleNewUserBySchoologyName, handleUserBySchoologyId } from "store/schoologyauth/thunks";
//  -- Thunks -------------------------
import { find, get, isEmpty, map } from 'lodash';
import { lighten } from 'polished';
import { createKeystore } from "store/keystore/thunks";
import { v4 } from 'uuid';
import { handleFetchSchoologyUserInfo } from 'store/schoology/thunks';
import { getUserIntegration } from 'utils';
import SentryWrap from 'components/Sentry';
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Wrapper = styled.div`
	height: 100%;
	width: 100%;
`;

const Error = styled.div`
    background-color: ${lighten(0.4, 'red')};
    border: 1px solid red;
    border-radius: 3px;
    color: red;
    font-size: 14px;
    font-weight: 500;
    margin: 0px auto 16px;
    max-width: 480px;
    padding: 8px;
    text-align: center;
    width: 100%;
`;
const Label = styled.div`
   font-size:14px;
   color:${COLOR.white};
`;
const LabelTop = styled.div`
   font-size:18px;
   color:${COLOR.white};
`;
const ItemsTabsList = styled.div`
  display: inline-block;
  flex-direction: column;
  min-height: 100px;
  border-radius: 12px;
  min-width: 200px;
  background-color: ${COLOR.indigodeep};
  width: 90%;
  padding: 16px;
  margin-top: 10px;
  min-height: 220px;
`;
const ClassUsersWrapper = styled.div`
    border: 1px dashed ${COLOR.black700};
    border-radius: 3px;
    margin-bottom: 8px;
    width:102%;
    &:last-child {
        margin-bottom: 0px;
    }
`;


const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;



const ContentArea = styled.div`
width: 90%;
margin-top: 28px;
`;
//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------


const UserInfoAres = ({ schoologyData, data, fechingSchoology }) => {
    const schoologyFields = [
        { label: 'Uid', path: 'users.uid', monospace: true, wordBreak: true },
        { label: 'School Id', path: 'users.school_id' },
        { label: 'First Name', path: 'users.name_first' },
        { label: 'Last name', path: 'users.name_last' },
        { label: 'Email', path: 'users.primary_email', wordBreak: true },
        { label: 'Building Id', path: 'users.building_id' }
    ];
    
    return (
        <Row style={{width:"100%"}}>
            <UserInfoCard data={data} userPath="users" showSchoolDistrict={false} />
            <IntegrationUserCard
                integrationData={schoologyData}
                title="User on Schoology"
                userPath="users"
                fields={schoologyFields}
                loading={fechingSchoology}
            />
        </Row>
    );
}
const ClassInfoArea = ({ handleChange, data, classEpendOwe, schoologyData }) => {
    const activeClassesColumns = [
        { label: 'Id', path: 'id', showTooltip: true },
        { label: 'Username', path: 'username' },
        { label: 'First name', path: 'firstName' },
        { label: 'Last Name', path: 'lastName' },
        { label: 'Schoology Id', path: 'schoologyid' },
        { label: 'Password', path: 'password', decodePassword: true }
    ];
    
    const integrationClassesColumns = [
        { label: 'Uid', path: 'uid', showTooltip: true },
        { label: 'School uid', path: 'school_uid' },
        { label: 'First name', path: 'name_first' },
        { label: 'Last Name', path: 'name_last' },
        { label: 'status', path: 'status' },
        { label: 'Admin', path: 'admin', formatValue: (val) => val == 1 ? "true" : "false" }
    ];
    
    return (
        <Row style={{width:"100%", marginTop: "32px"}}>
            <ClassInfoCard
                classes={data.classes || []}
                title="Active Classes"
                expandedId={classEpendOwe}
                onExpandChange={handleChange}
                getClassId={(cls) => cls.sectionId}
                getClassName={(cls) => cls.displayName}
                getClassUsers={(cls) => cls.classUsers || []}
                headerGradient="linear-gradient(135deg, #007bff 0%, #0056b3 100%)"
                tableColumns={activeClassesColumns}
                colSpan={12}
            />
            <ClassInfoCard
                classes={schoologyData.classes || []}
                title="Integration Classes"
                expandedId={classEpendOwe}
                onExpandChange={handleChange}
                getClassId={(cls) => cls.sectionId}
                getClassName={(cls) => `Course: ${cls.course_title} -- Section: ${cls.section_title}`}
                getClassUsers={(cls) => cls.classUsers || []}
                headerGradient="linear-gradient(135deg, #6f42c1 0%, #5a2d91 100%)"
                tableColumns={integrationClassesColumns}
                colSpan={12}
                colStyle={{paddingLeft: "16px", paddingRight: 0}}
            />
        </Row>
    );
}
const LogsContainer = ({
}) => {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({ users: null, classes: [], auth: null });
    const [schoologyData, setSchoologyUserData] = useState({ users: null, classes: [], auth: null });
    const [schoology_id, setSchoology] = useState("")
    const [schoologyName, setSchoologyName] = useState("")
    const [errorMessage, setErrorMessage] = useState(null)
    const [classEpendOwe, setClassExpendOwe] = useState(-1)
    const [userList, setUserList] = useState([])
    const [openModal, setOpenModal] = useState(false)
    const [fechingSchoology, setFechingSchoology] = useState(false)

    const handleChange = (panel) => (event, newExpanded) => {
        setClassExpendOwe(newExpanded ? panel : -1);
    };




    const fetchApis = async (id) => {
        setLoading(id)
        setErrorMessage(null)
        setFechingSchoology(true)
        setSchoologyUserData({ users: null, classes: [], auth: null })
        const result = await handleUserBySchoologyId(id)
        if (result.error) {
            setErrorMessage(result.message)
            setLoading(null)
            return;
        }
        const _user = find(userList,["schoologyid",id])
        setData({
            auth: get(result, "auth"),
            users: _user?_user:get(result, "users"),
            classes: get(result, "classes", []),
        })
        setOpenModal(true)
        if (result.auth) {
            await fetchFromSchoology(get(result, "users", {}))
        } else {
            setErrorMessage("No authentication was found for this Schoology user, which is why they are unable to fetch user data from Schoology.")
            setFechingSchoology(false)
        }
        setLoading(null)
    }
    const fetchFromSchoology = async (user) => {
        const data  = await  handleFetchSchoologyUserInfo(user.id)
        if(data&&data.success){
            const { classes , userInfo } = data.data;
            setFechingSchoology(false)
            setSchoologyUserData({
                classes: classes,
                users: userInfo
            })
        }else{
            setErrorMessage("Unable to fetch user data from schoology")
            setFechingSchoology(false)   
        }
    }
    const fetchSchoologyUserByName = async () => {
        if (schoologyName) {
            setLoading(true)
            // const userFromSchoology = await handleUserBySchoologyName(schoologyName.trim())
            const userFromSchoology = await handleNewUserBySchoologyName(schoologyName.trim(), 'schoology')
            setUserList(userFromSchoology)
            setSchoologyUserData({ users: null, classes: [], auth: null })
            setLoading(false)
        }

    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setUserList([])
        if (schoology_id) {
            fetchApis(schoology_id);
            fetchSchoologyUserByName()
        } else {
            fetchSchoologyUserByName()
        }

    };

    return (
        <SentryWrap>
            <Modal
                open={openModal}
                onClose={e => setOpenModal(false)}
                style={{ height: "100%", width: "100%" }}
            >
                <ModalContent>
                    <Row style={{ justifyContent: "flex-end", width:"100%" }}>
                        <IconButton
                            onClick={e => setOpenModal(false)}
                            style={{ padding: 0, marginRight: 10 }}
                        >
                            <Close color="secondary" />
                        </IconButton>
                    </Row>
                    {errorMessage ? <Error>{errorMessage}</Error> : null}
                    <ModalSection>
                        <UserInfoAres data={data} schoologyData={schoologyData} fechingSchoology={fechingSchoology} />
                        <ClassInfoArea data={data} schoologyData={schoologyData} classEpendOwe={classEpendOwe} handleChange={handleChange} />
                    </ModalSection>
                  
                </ModalContent>
            </Modal>
            <SearchForm
                title="Schoology User Search"
                searchValue={schoologyName}
                onSearchChange={e => {
                    setErrorMessage(null);
                    setSchoologyName(e.target.value);
                }}
                onSubmit={handleSubmit}
                loading={loading}
                additionalFields={[
                    {
                        component: (
                            <Col span={4} key="schoology_id">
                                <TextField
                                    id="schoology_id"
                                    name="schoology_id"
                                    label="Schoology id"
                                    InputLabelProps={{ shrink: true }}
                                    type="text"
                                    variant="outlined"
                                    onChange={e => {
                                        setErrorMessage(null);
                                        setSchoology(e.target.value);
                                    }}
                                    value={schoology_id}
                                    style={{ width: '100%' }}
                                    InputProps={{
                                        style: {
                                            height: '40px',
                                            fontSize: '14px',
                                            borderRadius: '8px'
                                        }
                                    }}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '&:hover fieldset': {
                                                borderColor: '#007bff',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#007bff',
                                            },
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': {
                                            color: '#007bff',
                                        }
                                    }}
                                />
                            </Col>
                        ),
                        separator: 'Or'
                    }
                ]}
            />
            <Wrapper>
                <LoadingWrapper loading={false}>
                    {userList.length > 0 ? <Table style={{ width: "100%", textAlign: "center" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ textAlign: "center" }}>Username</TableCell>
                                <TableCell style={{ textAlign: "center" }}>First name</TableCell>
                                <TableCell style={{ textAlign: "center" }}>Last Name</TableCell>
                                <TableCell style={{ textAlign: "center" }}>role</TableCell>
                                <TableCell style={{ textAlign: "center" }}>Schoology Id</TableCell>
                                <TableCell style={{ textAlign: "center" }}>Password</TableCell>
                                <TableCell style={{ textAlign: "center" }}>Compare</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {map(userList, cuser => {
                                return (<>
                                    <TableRow key={cuser.id}>
                                        <TableCell style={{ textAlign: "center" }}>{get(cuser, "username", '')}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{get(cuser, "firstName", '')}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{get(cuser, "lastName", '')}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{get(cuser, "role", '')}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}>{get(cuser, "schoologyid", '')}</TableCell>
                                        <TableCell style={{ textAlign: "center" }}><PasswordRevealInline userId={get(cuser, "id")} username={get(cuser, "username")} /></TableCell>
                                        <TableCell style={{ textAlign: "center" }}>
                                            <IconButton onClick={() => fetchApis(get(cuser, "schoologyid"))}>
                                                {loading == get(cuser, "schoologyid") ? <Loading size={14}/> : <Visibility style={{ color: COLOR.green }} />}
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                </>)
                            })}
                        </TableBody>
                    </Table> : null}
                </LoadingWrapper>
            </Wrapper>
        </SentryWrap>
    );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({
    logs: state.logs,
    currentUser: state.currentUser
});

export default connect(mapStateToProps, null)(LogsContainer);
